import type { RouteRecordRaw } from "vue-router";
import { Module } from "@/modules/tenantWebsite/enums";

export default <RouteRecordRaw[]>[
  {
    path: "/appointment/:code",
    meta: {
      module: Module.Appointment,
    },
    children: [
      {
        path: "",
        name: "appointment.show",
        component: () =>
          import("@/modules/tenantWebsite/appointment/views/AppointmentView.vue"),
      },
    ],
  },
];
